import { resolvedTenantConfig } from '@app/tenant';

export const appConfig = {
  format: {
    date: 'MM/DD/YYYY',
    isoDateTime: 'YYYY-MM-DDTHH:mm:ss',
    shortDate: 'MM/DD',
    time: 'HH:mm',
  },
  apiHost: process.env.REACT_APP_API_HOST,
  // D6: `resolvedTenantConfig` is the always-defined module-scope fallback (neutral on an unknown
  // hostname), matching how `theme.tsx`'s `palette` reads tenant state — see `@app/tenant`.
  appUrl: resolvedTenantConfig.urls.marketingBase,
};
